/**
 * Scroll observer - https://css-tricks.com/using-intersectionobserver-to-check-if-page-scrolled-past-certain-point/
 */


/**
 * Mobile menu
 */
 var component_scroll_observer = function(args) {

  var header = document.querySelector('.site-header')

  if(args.class == null) {
    args.class = document.querySelector('.site-content');
  }

  let observer = new IntersectionObserver(entries => {
    console.log(entries);
    if (entries[0].boundingClientRect.y < 0) {

      if (header.classList.contains('scrolled-past-hero')) {
        header.classList.remove('scrolled-past-hero');
      } else {
        header.classList.add('scrolled-past-hero');
      }

    }
  });

  observer.observe(args.class);

  // make the call chainable
  return this;

};
